import router from '../router';
import store from '../store'
import postRobot from 'post-robot';

function navigate(url) {
    if(claimsLink.jitbitSession) {
        router.push(url);
    }
}

function letOtherTabsKnowAboutMe() {
    localStorage.setItem('jitbit-session', 'true'); 
}

function removeMeFromOtherTabsWhenIClose() {
    window.addEventListener('beforeunload', () => {
        localStorage.removeItem('jitbit-session');
    });    
}

function getBroadcastChannel() {
    try {
        return new BroadcastChannel('jitbit-channel');
    }
    catch (e) {
        return {};
    }    
}

const claimsLink = {
    set jitbitSession(value) {
        // stored in session storage because it is tab specific
        // and will persist on reloads
        sessionStorage.setItem('jitbit-session', 'true');
    },
    get jitbitSession() {
        return sessionStorage.getItem('jitbit-session') != null;
    },
    channel: getBroadcastChannel(),
    subscribers: {},
    initialized: false,

    init() {
        if(window.location.href.includes('jitbit=true')) {
            this.jitbitSession = true;
        }
        
        if(this.jitbitSession) {
            letOtherTabsKnowAboutMe();
            removeMeFromOtherTabsWhenIClose();            
        }
    },

    viewPlan(data) {
        navigate(`/employer/${data.employerId}/plans?planId=${data.planId}`);
    },

    viewParticipant(data) {
        navigate(`/participant/${data.participantId}/general`);
    },

    viewEmployer(data) {
        navigate(`/employer/${data.employerId}/general`);
    }
}

claimsLink.subscribers = {
    'view-employer' : claimsLink.viewEmployer,
    'view-participant': claimsLink.viewParticipant,
    'view-plan': claimsLink.viewPlan
}

if(!claimsLink.initialized) {
    claimsLink.channel.onmessage = (e) => {
        var event = e.data;
        var s = claimsLink.subscribers[event.message];
        if(s) s(event);
    }

    claimsLink.initialized = true;
}

postRobot.on('is-logged-in', (event) => {
    let loggedIn = store.getters['session/loggedIn'];
    return loggedIn;
});

postRobot.on('jitbit-tab-exists', () => {
    return localStorage.getItem('jitbit-session') != null;
});

postRobot.on('get-url-templates', () => {
    return {
        participant: 'participant/{participantId}/general',
        plan: 'employer/{employerId}/plans?planId={planId}',
        employer: 'employer/{employerId}/general',
    }
});

postRobot.on('jitbit-message', (event) => {
    claimsLink.channel.postMessage(event.data);
});

export default claimsLink;


// WEBPACK FOOTER //
// ./src/dashboards/claims-ipc.js